import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";

import { useCoachPoolContext } from "../../../../contexts/CoachPoolContext";

export default function Filters({ keyword, setKeyword }) {
  const { dispatch, actions, state } = useCoachPoolContext();

  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <form className="inviteSearch_form">
            <input
              type="text"
              placeholder="Name"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </form>
        </Col>
        <Col md={9} className="text-right">
          <Button
            onClick={() => actions.showCreateForm(dispatch)}
            bsStyle="primary"
          >
            Add New
          </Button>
        </Col>
      </Row>
    </div>
  );
}
